import { Button, Icon, Upload, Notification, Popover } from "@cea/ui-kit";
import PropTypes from "prop-types";
import { useContext, useRef, useState } from "react";

import FileUploadContext from "../../contexts/FileUploadContext";

import styles from "./unified-upload.module.css";

const UnifiedUpload = ({ onChange, shouldAllowZip = false }) => {
  const fileInputRef = useRef(null);
  const [fileList, setFileList] = useState([]);
  const { addFileUploadJob, currentFileUploadJobId, removeFileUploadJob } =
    useContext(FileUploadContext);

  const handleFileChange = (event) => {
    try {
      const files = event.target.files;

      const zipFiles = Array.from(files).filter((file) =>
        file.name.toLowerCase().endsWith(".zip")
      );

      if (zipFiles.length > 1) {
        throw new Error(
          "Multiple zip files (SharePoint Directory) are not allowed!"
        );
      }

      if (!shouldAllowZip && zipFiles.length > 0) {
        throw new Error("Zip  file (SharePoint Directory) is not supported!");
      }

      if (files.length > 1 && zipFiles.length > 0) {
        throw new Error(
          "Zip (SharePoint Directory) uploads cannot be batched with other files!"
        );
      }

      if (files.length > 0) {
        const newFileList = Array.from(files).map((file) => ({
          id: crypto.randomUUID(),
          name: file.name,
          originalFileObj: file,
          jobId: currentFileUploadJobId,
        }));

        addFileUploadJob(newFileList);

        setFileList((prevValue) => [...prevValue, ...newFileList]);
        onChange(newFileList);
      }
    } catch (error) {
      Notification.error({
        message: error.message,
      });
    }
  };

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <div className={styles["upload-button-container"]}>
        <Button
          type="primary"
          icon={<Icon name="file" color="var(--primary-white)" size={12} />}
          className={styles["upload-button"]}
          onClick={handleFileUpload}
          size="small"
        >
          Upload Files
        </Button>
        <Popover
          placement="right"
          title={`Files Supported: XLSX, DOC, PDF ${
            shouldAllowZip ? ", ZIP" : ""
          } `}
          content={`${
            shouldAllowZip
              ? "\n\nTo upload directories, please compress your folder and then upload. Data will be inserted as found in the zip file."
              : ""
          }`}
        >
          <Icon name="issues_circle" size={16} />
        </Popover>
      </div>
      <input
        type="file"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Upload
        fileList={fileList}
        onRemove={(file) => {
          const updatedFileList = fileList.filter(
            (item) => item.uid !== file.uid
          );

          removeFileUploadJob(file.id);
          setFileList(updatedFileList);
          onChange(updatedFileList);
        }}
      />
    </>
  );
};

UnifiedUpload.propTypes = {
  onChange: PropTypes.func,
  shouldAllowZip: PropTypes.bool,
  value: PropTypes.array,
};

export default UnifiedUpload;
